import styles from './confidentiality.module.sass';
import { useTranslation } from 'react-i18next';

const Сonfidentiality = () => {
  const { t } = useTranslation();

  return (
    <p className={styles.text}>
      {t('additionalPages.continueAgreement')}
      <a
        className={styles.link}
        href={require('../../assets/pdfs/personal-data-policy.pdf')}
        target="_blank"
      >
        {t('additionalPages.privacyPolicyShort')}
      </a>{' '}
      {t('additionalPages.and')}{' '}
      <a
        className={styles.link}
        href={require('../../assets/pdfs/public-offer.pdf')}
        target="_blank"
      >
        {t('additionalPages.publicOfferShort')}
      </a>
    </p>
  );
};
export default Сonfidentiality;
